$(function() {

    // toggle dropdown
    $("body").on("click",".form-filter > .placeholder", function(e) {
        e.preventDefault();
        var that = $(this);
        var filter = that.closest(".form-filter");

        if(!filter.parents('.form-filter.collapsed').length) {
            $(".form-filter.collapsed").not(filter).removeClass("collapsed");
        } else {
            filter.closest('.form-filter.collapsed').find(".form-filter.collapsed").not(filter).removeClass("collapsed");
        }

        if(filter.hasClass("collapsed")) { filter.removeClass("collapsed"); } else { filter.addClass("collapsed"); }
    });

    $("body").on("click", function(e) {
        var target = $(e.target);
        if(!target.parents(".form-filter").length) { $(".form-filter.collapsed").removeClass("collapsed");  }
    });

    $('.form-filter input, .form-filter select').on("keyup paste reset-placeholder",function(e) {
        var filter = $(this).closest(".form-filter");
        var placeholder = filter.find(".placeholder");

        if(filter.hasClass("checkbox_list") || filter.hasClass("range")) return;

        if(!placeholder.attr("data-default").length) {
            placeholder.attr("data-default", placeholder.html());
        }

        if($(this).val().length) {
            var value_labels = (typeof placeholder.attr("data-prefix") !== typeof undefined) && placeholder.attr("data-prefix").length ? placeholder.attr("data-prefix")+' ' : '';
            value_labels += $(this).val();
            value_labels += ((typeof placeholder.attr("data-suffix") !== typeof undefined) && placeholder.attr("data-suffix").length ? ' '+placeholder.attr("data-suffix") : '');
            placeholder.html(value_labels);
        } else {
            placeholder.html(placeholder.attr("data-default"));
        }

        var multi_dropdown = filter.closest(".form-filter.multi");
        if(multi_dropdown.length) {
            // console.log("dsadas");
        }

    });

    $('.form-filter.checkbox_list input[type="radio"], .form-filter.checkbox_list input[type="checkbox"]').on("change reset-placeholder",function() {
        var filter = $(this).closest(".form-filter");
        var placeholder = filter.find(".placeholder");

        var inputName = $(this).attr("name");
        var group = filter.find('input[name="'+inputName+'"]:checked');

        if(!placeholder.attr("data-default").length) {
            placeholder.attr("data-default", placeholder.html());
        }

        if(group.length) {
            var value_labels = (typeof placeholder.attr("data-prefix") !== typeof undefined) && placeholder.attr("data-prefix").length ? placeholder.attr("data-prefix")+' ' : '';
            $.each(group, function(i ,el){
                if($(el).val().length) {
                    value_labels += $(el).next().html() + ", ";
                }
            });

            value_labels = (value_labels.length ? value_labels.slice(0, -2) : value_labels);
            value_labels += ((typeof placeholder.attr("data-suffix") !== typeof undefined) && placeholder.attr("data-suffix").length ? ' '+placeholder.attr("data-suffix") : '');

            placeholder.html(value_labels);
        } else {
            placeholder.html(placeholder.attr("data-default"));
        }
    });

    $('.form-filter.range input[type="number"]').on("keyup paste reset-placeholder",function(e) {
        var filter = $(this).closest(".form-filter");
        var placeholder = filter.find(".placeholder");

        var is_min = $(this).attr("name").indexOf("[min]") !== -1;
        var other_input = filter.find('input[name="'+( is_min ? $(this).attr("name").replace("[min]","[max]") : $(this).attr("name").replace("[max]","[min]") )+'"]');

        if(!placeholder.attr("data-default").length) {
            placeholder.attr("data-default", placeholder.html());
        }

        // if(is_min) {
        //     other_input.attr("min", parseInt($(this).val()));
        //     other_input.prop("min", parseInt($(this).val()));
        // } else {
        //     other_input.attr("max", parseInt($(this).val()));
        //     other_input.prop("max", parseInt($(this).val()));
        // }

        // if(!is_min && !other_input.val().length) {
        //     $(this).val("");
        //     $(this).removeAttr("min").removeAttr("max");
        //     $(this).removeProp("min").removeProp("max");
        // } else if(is_min && !$(this).val().length && other_input.val().length) {
        //     // other_input.val("");
        //     other_input.removeAttr("min").removeAttr("max");
        //     other_input.removeProp("min").removeProp("max");
        // }

        if(!$(this).val().length && !other_input.val().length) {
            placeholder.html(placeholder.attr("data-default"));
        } else {
            var value_labels = (typeof placeholder.attr("data-prefix") !== typeof undefined) && placeholder.attr("data-prefix").length ? placeholder.attr("data-prefix")+' ' : '';

            if(is_min) {
                if($(this).val() && other_input.val().length) {
                    value_labels += $(this).val() + (other_input.val().length ? ' - '+other_input.val() : '');
                } else if(!$(this).val().length && other_input.val().length) {
                    value_labels += "sub " + other_input.val();
                } else if($(this).val().length && !other_input.val().length) {
                    value_labels += "peste " + $(this).val();
                }
            } else {
                if($(this).val() && other_input.val().length) {
                    value_labels += $(this).val() + (other_input.val().length ? ' - '+other_input.val() : '');
                } else if(!$(this).val().length && other_input.val().length) {
                    value_labels += "peste " + other_input.val();
                } else if($(this).val().length && !other_input.val().length) {
                    value_labels += "sub " + $(this).val();
                }
            }

            value_labels = value_labels + ((typeof placeholder.attr("data-suffix") !== typeof undefined) && placeholder.attr("data-suffix").length ? ' '+placeholder.attr("data-suffix") : '');
            placeholder.html(value_labels);
        }
    });

    $('.form-filter input[type="number"]').on("change",function(e) {
        if(
            typeof $(this).attr("min") !== typeof undefined && $(this).val() < parseInt($(this).attr("min")) ||
            typeof $(this).attr("max") !== typeof undefined && $(this).val() > parseInt($(this).attr("max"))
        ) {
            $(this).val("").trigger("reset-placeholder").focus();
        }
    });

    $('.form-filter input, .form-filter select').trigger("reset-placeholder"); // refresh filters...
    $('.search_filters_form').addClass("loaded");
});


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/filters.js